import styled from 'styled-components';

// Container, Content, Title, Description and CtaLink are shared with the sold-out state
// (NEWB-900): same centered column layout, typography, colors and Figma CTA.
export { Container, Content, CtaLink, Description, Title } from '../ResaleSoldOutState/styles';

const ICON_SIZE = { desktop : 140, mobile : 100 };

export const Icon = styled.img`
  width: ${ICON_SIZE.desktop}px;
  height: ${ICON_SIZE.desktop}px;

  ${({ theme }) => theme.media.mobile} {
    width: ${ICON_SIZE.mobile}px;
    height: ${ICON_SIZE.mobile}px;
  }
`;

export const Texts = styled.div`
  display: flex;
  width: 100%;
  max-width: 758px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
